import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';
import { indexBy } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
import { createSelector } from '@atlassian/jira-portfolio-3-portfolio/src/common/reselect';

export type {
	IssuePriority,
	IssuePriorities,
} from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issue-priorities/types';

export const getIssuePriorities = (state: State) => state.domain.issuePriorities;

export const getIssuePrioritiesById = createSelector([getIssuePriorities], (issuePriorities) =>
	indexBy(({ id }) => id, Object.values(issuePriorities)),
);

export const getIssuePrioritiesIdList = createSelector([getIssuePriorities], (issuePriorities) => {
	const issuePrioritiesIdList = Object.values(issuePriorities)
		.sort((a, b) => a.sequence - b.sequence)
		.map(({ id }) => id);

	return issuePrioritiesIdList.length ? issuePrioritiesIdList : null;
});
